import { PMDescriptionCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { DashboardCardContext } from "../context";

export function addProgramDescriptionCard(ctx: DashboardCardContext) {
  const { view, language } = ctx;

  const programDescriptionComponent = view.addComponent({
    component: PMDescriptionCard,
    layoutProps: {
      componentId: "programDescriptionComponent",
      title: "",
      description: "",
      labels: ["Program", "Description"],
    },
  });

  programDescriptionComponent.mapLayoutProps(({ language }) => ({
    componentId: "programDescriptionComponent",
    labels: ["Program", "Description"],
    title: getLocalizedMessage(
      language || "en",
      "reportingStructure.programDescription"
    ),
    description: getLocalizedMessage(
      language || "en",
      "showsProgramDescription"
    ),
  }));

  programDescriptionComponent.mapState(({ settings }) => ({
    title: getLocalizedMessage(
      language || "en",
      "reportingStructure.programDescription"
    ),
    text: settings?.configuration?.programDescription ?? "",
  }));
}
